export { default as DotsHorizontalOutlineIcon } from './DotsHorizontalOutlineIcon';
